import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class ProfileDefaultGuard {
  constructor(private authenticationService: AuthenticationService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.authenticationService.getPlanFeaturesEnabled().pipe(
      map(plan => {
        const availableSkins = Array.isArray(plan?.available_dashboard_skins)
          ? plan.available_dashboard_skins : [];
        const selectedSkin = ['logistics', 'tax_accountancy'].includes(plan?.default_skin) &&
          availableSkins.includes(plan.default_skin)
          ? plan.default_skin : null;
        return selectedSkin
          ? this.router.createUrlTree(['/profile', route.paramMap.get('id'),
              selectedSkin === 'tax_accountancy' ? 'tax-accountancy' : 'logistics'], {
              queryParams: route.queryParams,
              fragment: route.fragment,
            })
          : true;
      }),
      catchError(() => of(true))
    );
  }
}
